@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.youndie.site.components.layouts.LibraryLayout as _dev_youndie_site_components_layouts_LibraryLayout
import dev.youndie.site.components.layouts.MarkdownLayout as _dev_youndie_site_components_layouts_MarkdownLayout
import dev.youndie.site.components.layouts.PageLayout as _dev_youndie_site_components_layouts_PageLayout
import dev.youndie.site.pages.AboutPage as _dev_youndie_site_pages_AboutPage
import dev.youndie.site.pages.AppframePage as _dev_youndie_site_pages_AppframePage
import dev.youndie.site.pages.BochkaPage as _dev_youndie_site_pages_BochkaPage
import dev.youndie.site.pages.BooblikPage as _dev_youndie_site_pages_BooblikPage
import dev.youndie.site.pages.ChronikPage as _dev_youndie_site_pages_ChronikPage
import dev.youndie.site.pages.HomePage as _dev_youndie_site_pages_HomePage
import dev.youndie.site.pages.KafkaknPage as _dev_youndie_site_pages_KafkaknPage
import dev.youndie.site.pages.KatcherPage as _dev_youndie_site_pages_KatcherPage
import dev.youndie.site.pages.KompotPage as _dev_youndie_site_pages_KompotPage
import dev.youndie.site.pages.KorePage as _dev_youndie_site_pages_KorePage
import dev.youndie.site.pages.KvadrantUiPage as _dev_youndie_site_pages_KvadrantUiPage
import dev.youndie.site.pages.ManiPage as _dev_youndie_site_pages_ManiPage
import dev.youndie.site.pages.MetrikPage as _dev_youndie_site_pages_MetrikPage
import dev.youndie.site.pages.MongknPage as _dev_youndie_site_pages_MongknPage
import dev.youndie.site.pages.MostikPage as _dev_youndie_site_pages_MostikPage
import dev.youndie.site.pages.PetichPage as _dev_youndie_site_pages_PetichPage
import dev.youndie.site.pages.S3knPage as _dev_youndie_site_pages_S3knPage
import dev.youndie.site.pages.SborkaPage as _dev_youndie_site_pages_SborkaPage
import dev.youndie.site.pages.ShashkiPage as _dev_youndie_site_pages_ShashkiPage
import dev.youndie.site.pages.ShildikPage as _dev_youndie_site_pages_ShildikPage
import dev.youndie.site.pages.SmtpknPage as _dev_youndie_site_pages_SmtpknPage
import dev.youndie.site.pages.TelekPage as _dev_youndie_site_pages_TelekPage
import dev.youndie.site.pages.TracyPage as _dev_youndie_site_pages_TracyPage
import dev.youndie.site.pages.ViddikPage as _dev_youndie_site_pages_ViddikPage
import dev.youndie.site.pages.XykPage as _dev_youndie_site_pages_XykPage
import dev.youndie.site.pages.ZavarnikPage as _dev_youndie_site_pages_ZavarnikPage
import dev.youndie.site.pages.blog.ABrokerThatFitsInOneHeadPage as _dev_youndie_site_pages_blog_ABrokerThatFitsInOneHeadPage
import dev.youndie.site.pages.blog.AKotlinServerThatShipsTwicePage as _dev_youndie_site_pages_blog_AKotlinServerThatShipsTwicePage
import dev.youndie.site.pages.blog.AScreenEditorForBackendDrivenUiPage as _dev_youndie_site_pages_blog_AScreenEditorForBackendDrivenUiPage
import dev.youndie.site.pages.blog.AnIdentityProviderForFortySixMegabytesPage as _dev_youndie_site_pages_blog_AnIdentityProviderForFortySixMegabytesPage
import dev.youndie.site.pages.blog.AskTheDesktopPage as _dev_youndie_site_pages_blog_AskTheDesktopPage
import dev.youndie.site.pages.blog.BackendDrivenUiForKotlinMultiplatformPage as _dev_youndie_site_pages_blog_BackendDrivenUiForKotlinMultiplatformPage
import dev.youndie.site.pages.blog.BlogIndexPage as _dev_youndie_site_pages_blog_BlogIndexPage
import dev.youndie.site.pages.blog.BotsAsStateMachinesPage as _dev_youndie_site_pages_blog_BotsAsStateMachinesPage
import dev.youndie.site.pages.blog.BugsThatDontFailPage as _dev_youndie_site_pages_blog_BugsThatDontFailPage
import dev.youndie.site.pages.blog.CracOnAKtorServiceWithHikariAndExposedPage as _dev_youndie_site_pages_blog_CracOnAKtorServiceWithHikariAndExposedPage
import dev.youndie.site.pages.blog.CrashTrackerKotlinNativePage as _dev_youndie_site_pages_blog_CrashTrackerKotlinNativePage
import dev.youndie.site.pages.blog.DispatcherParallelismOnKotlinNativePage as _dev_youndie_site_pages_blog_DispatcherParallelismOnKotlinNativePage
import dev.youndie.site.pages.blog.DocsBootstrapPage as _dev_youndie_site_pages_blog_DocsBootstrapPage
import dev.youndie.site.pages.blog.GreenIsNotCheckedPage as _dev_youndie_site_pages_blog_GreenIsNotCheckedPage
import dev.youndie.site.pages.blog.InstrumentationPgoOnKotlinNativePage as _dev_youndie_site_pages_blog_InstrumentationPgoOnKotlinNativePage
import dev.youndie.site.pages.blog.JvmAndNativeDifferencesPage as _dev_youndie_site_pages_blog_JvmAndNativeDifferencesPage
import dev.youndie.site.pages.blog.KapkanPage as _dev_youndie_site_pages_blog_KapkanPage
import dev.youndie.site.pages.blog.KotlinNativeFromScratchPage as _dev_youndie_site_pages_blog_KotlinNativeFromScratchPage
import dev.youndie.site.pages.blog.LeydenAotCacheForAPlainKotlinJvmServicePage as _dev_youndie_site_pages_blog_LeydenAotCacheForAPlainKotlinJvmServicePage
import dev.youndie.site.pages.blog.LogsForAnAgentToReadPage as _dev_youndie_site_pages_blog_LogsForAnAgentToReadPage
import dev.youndie.site.pages.blog.MetroForComposeMultiplatformPage as _dev_youndie_site_pages_blog_MetroForComposeMultiplatformPage
import dev.youndie.site.pages.blog.NativeUnderLoadPage as _dev_youndie_site_pages_blog_NativeUnderLoadPage
import dev.youndie.site.pages.blog.PercentilesDontAveragePage as _dev_youndie_site_pages_blog_PercentilesDontAveragePage
import dev.youndie.site.pages.blog.ScreenshotFixturesFromPreviewPage as _dev_youndie_site_pages_blog_ScreenshotFixturesFromPreviewPage
import dev.youndie.site.pages.blog.ScreenshotsWithoutAnEmulatorPage as _dev_youndie_site_pages_blog_ScreenshotsWithoutAnEmulatorPage
import dev.youndie.site.pages.blog.ServerRenderingKobwebPage as _dev_youndie_site_pages_blog_ServerRenderingKobwebPage
import dev.youndie.site.pages.blog.SilenceIsNotACleanRunPage as _dev_youndie_site_pages_blog_SilenceIsNotACleanRunPage
import dev.youndie.site.pages.blog.SmtpFromTheSpecPage as _dev_youndie_site_pages_blog_SmtpFromTheSpecPage
import dev.youndie.site.pages.blog.StaleAotCacheOnJdk25Page as _dev_youndie_site_pages_blog_StaleAotCacheOnJdk25Page
import dev.youndie.site.pages.blog.ThePathYouSignedPage as _dev_youndie_site_pages_blog_ThePathYouSignedPage
import dev.youndie.site.pages.blog.TheScreenshotIsTheTestPage as _dev_youndie_site_pages_blog_TheScreenshotIsTheTestPage
import dev.youndie.site.pages.blog.ThreeKtorEnginesUnderOneProtocolPage as _dev_youndie_site_pages_blog_ThreeKtorEnginesUnderOneProtocolPage
import dev.youndie.site.pages.blog.UnderAContainerLimitPage as _dev_youndie_site_pages_blog_UnderAContainerLimitPage
import dev.youndie.site.pages.blog.UserCodeShareOfAKtorServicePage as _dev_youndie_site_pages_blog_UserCodeShareOfAKtorServicePage
import dev.youndie.site.pages.blog.WhatIsInAKotlinNativeBinaryPage as _dev_youndie_site_pages_blog_WhatIsInAKotlinNativeBinaryPage
import dev.youndie.site.pages.blog.WhatIsLeftIfYouDieHalfwayPage as _dev_youndie_site_pages_blog_WhatIsLeftIfYouDieHalfwayPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "kotlin.website"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "dev.youndie.site.components.layouts.LibraryLayout",
            parentLayoutId = "dev.youndie.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.components.layouts.initLibraryLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_youndie_site_components_layouts_LibraryLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "dev.youndie.site.components.layouts.MarkdownLayout",
            parentLayoutId = "dev.youndie.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_youndie_site_components_layouts_MarkdownLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "dev.youndie.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.components.layouts.initPageLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_youndie_site_components_layouts_PageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "dev.youndie.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "dev.youndie.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_AboutPage()
        }
        ctx.router.register(
            "/appframe",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initAppframePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_AppframePage()
        }
        ctx.router.register(
            "/blog/",
            layoutId = "dev.youndie.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initBlogIndex(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_BlogIndexPage()
        }
        ctx.router.register(
            "/blog/a-broker-that-fits-in-one-head",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initABrokerThatFitsInOneHeadPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_ABrokerThatFitsInOneHeadPage()
        }
        ctx.router.register(
            "/blog/a-kotlin-server-that-ships-twice",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initAKotlinServerThatShipsTwicePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_AKotlinServerThatShipsTwicePage()
        }
        ctx.router.register(
            "/blog/a-screen-editor-for-backend-driven-ui",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initAScreenEditorForBackendDrivenUiPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_AScreenEditorForBackendDrivenUiPage()
        }
        ctx.router.register(
            "/blog/an-identity-provider-for-forty-six-megabytes",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initAnIdentityProviderForFortySixMegabytesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_AnIdentityProviderForFortySixMegabytesPage()
        }
        ctx.router.register(
            "/blog/ask-the-desktop",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initAskTheDesktopPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_AskTheDesktopPage()
        }
        ctx.router.register(
            "/blog/backend-driven-ui-for-kotlin-multiplatform",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initBackendDrivenUiForKotlinMultiplatformPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_BackendDrivenUiForKotlinMultiplatformPage()
        }
        ctx.router.register(
            "/blog/bots-as-state-machines",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initBotsAsStateMachinesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_BotsAsStateMachinesPage()
        }
        ctx.router.register(
            "/blog/bugs-that-dont-fail",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initBugsThatDontFailPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_BugsThatDontFailPage()
        }
        ctx.router.register(
            "/blog/crac-on-a-ktor-service-with-hikari-and-exposed",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initCracOnAKtorServiceWithHikariAndExposedPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_CracOnAKtorServiceWithHikariAndExposedPage()
        }
        ctx.router.register(
            "/blog/crash-tracker-kotlin-native",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initCrashTrackerKotlinNativePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_CrashTrackerKotlinNativePage()
        }
        ctx.router.register(
            "/blog/dispatcher-parallelism-on-kotlin-native",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initDispatcherParallelismOnKotlinNativePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_DispatcherParallelismOnKotlinNativePage()
        }
        ctx.router.register(
            "/blog/docs-bootstrap",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initDocsBootstrapPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_DocsBootstrapPage()
        }
        ctx.router.register(
            "/blog/green-is-not-checked",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initGreenIsNotCheckedPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_GreenIsNotCheckedPage()
        }
        ctx.router.register(
            "/blog/instrumentation-pgo-on-kotlin-native",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initInstrumentationPgoOnKotlinNativePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_InstrumentationPgoOnKotlinNativePage()
        }
        ctx.router.register(
            "/blog/jvm-and-native-differences",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initJvmAndNativeDifferencesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_JvmAndNativeDifferencesPage()
        }
        ctx.router.register(
            "/blog/kapkan",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initKapkanPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_KapkanPage()
        }
        ctx.router.register(
            "/blog/kotlin-native-from-scratch",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initKotlinNativeFromScratchPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_KotlinNativeFromScratchPage()
        }
        ctx.router.register(
            "/blog/leyden-aot-cache-for-a-plain-kotlin-jvm-service",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initLeydenAotCacheForAPlainKotlinJvmServicePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_LeydenAotCacheForAPlainKotlinJvmServicePage()
        }
        ctx.router.register(
            "/blog/logs-for-an-agent-to-read",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initLogsForAnAgentToReadPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_LogsForAnAgentToReadPage()
        }
        ctx.router.register(
            "/blog/metro-for-compose-multiplatform",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initMetroForComposeMultiplatformPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_MetroForComposeMultiplatformPage()
        }
        ctx.router.register(
            "/blog/native-under-load",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initNativeUnderLoadPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_NativeUnderLoadPage()
        }
        ctx.router.register(
            "/blog/percentiles-dont-average",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initPercentilesDontAveragePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_PercentilesDontAveragePage()
        }
        ctx.router.register(
            "/blog/screenshot-fixtures-from-preview",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initScreenshotFixturesFromPreviewPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_ScreenshotFixturesFromPreviewPage()
        }
        ctx.router.register(
            "/blog/screenshots-without-an-emulator",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initScreenshotsWithoutAnEmulatorPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_ScreenshotsWithoutAnEmulatorPage()
        }
        ctx.router.register(
            "/blog/server-rendering-kobweb",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initServerRenderingKobwebPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_ServerRenderingKobwebPage()
        }
        ctx.router.register(
            "/blog/silence-is-not-a-clean-run",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initSilenceIsNotACleanRunPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_SilenceIsNotACleanRunPage()
        }
        ctx.router.register(
            "/blog/smtp-from-the-spec",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initSmtpFromTheSpecPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_SmtpFromTheSpecPage()
        }
        ctx.router.register(
            "/blog/stale-aot-cache-on-jdk25",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initStaleAotCacheOnJdk25Page(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_StaleAotCacheOnJdk25Page()
        }
        ctx.router.register(
            "/blog/the-path-you-signed",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initThePathYouSignedPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_ThePathYouSignedPage()
        }
        ctx.router.register(
            "/blog/the-screenshot-is-the-test",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initTheScreenshotIsTheTestPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_TheScreenshotIsTheTestPage()
        }
        ctx.router.register(
            "/blog/three-ktor-engines-under-one-protocol",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initThreeKtorEnginesUnderOneProtocolPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_ThreeKtorEnginesUnderOneProtocolPage()
        }
        ctx.router.register(
            "/blog/under-a-container-limit",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initUnderAContainerLimitPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_UnderAContainerLimitPage()
        }
        ctx.router.register(
            "/blog/user-code-share-of-a-ktor-service",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initUserCodeShareOfAKtorServicePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_UserCodeShareOfAKtorServicePage()
        }
        ctx.router.register(
            "/blog/what-is-in-a-kotlin-native-binary",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initWhatIsInAKotlinNativeBinaryPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_WhatIsInAKotlinNativeBinaryPage()
        }
        ctx.router.register(
            "/blog/what-is-left-if-you-die-halfway",
            layoutId = "dev.youndie.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.blog.initWhatIsLeftIfYouDieHalfwayPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_blog_WhatIsLeftIfYouDieHalfwayPage()
        }
        ctx.router.register(
            "/bochka",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initBochkaPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_BochkaPage()
        }
        ctx.router.register(
            "/booblik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initBooblikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_BooblikPage()
        }
        ctx.router.register(
            "/chronik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initChronikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_ChronikPage()
        }
        ctx.router.register(
            "/kafkakn",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initKafkaknPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_KafkaknPage()
        }
        ctx.router.register(
            "/katcher",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initKatcherPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_KatcherPage()
        }
        ctx.router.register(
            "/kompot",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initKompotPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_KompotPage()
        }
        ctx.router.register(
            "/kore",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initKorePage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_KorePage()
        }
        ctx.router.register(
            "/kvadrant-ui",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initKvadrantUiPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_KvadrantUiPage()
        }
        ctx.router.register(
            "/mani",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initManiPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_ManiPage()
        }
        ctx.router.register(
            "/metrik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initMetrikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_MetrikPage()
        }
        ctx.router.register(
            "/mongkn",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initMongknPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_MongknPage()
        }
        ctx.router.register(
            "/mostik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initMostikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_MostikPage()
        }
        ctx.router.register(
            "/petich",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initPetichPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_PetichPage()
        }
        ctx.router.register(
            "/s3kn",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initS3knPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_S3knPage()
        }
        ctx.router.register(
            "/sborka",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initSborkaPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_SborkaPage()
        }
        ctx.router.register(
            "/shashki",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initShashkiPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_ShashkiPage()
        }
        ctx.router.register(
            "/shildik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initShildikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_ShildikPage()
        }
        ctx.router.register(
            "/smtpkn",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initSmtpknPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_SmtpknPage()
        }
        ctx.router.register(
            "/telek",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initTelekPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_TelekPage()
        }
        ctx.router.register(
            "/tracy",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initTracyPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_TracyPage()
        }
        ctx.router.register(
            "/viddik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initViddikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_ViddikPage()
        }
        ctx.router.register(
            "/xyk",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initXykPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_XykPage()
        }
        ctx.router.register(
            "/zavarnik",
            layoutId = "dev.youndie.site.components.layouts.LibraryLayout",
            initRouteMethod = { ctx ->
                dev.youndie.site.pages.initZavarnikPage(ctx)
            },
        ) { pageCtx -> 
            _dev_youndie_site_pages_ZavarnikPage()
        }

        dev.youndie.site.initErrorPage(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        dev.youndie.site.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.youndie.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
